import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { regionCodes } from "common/static/regions";

import useAppVariant from "features/common/hooks/useAppVariant";
import { getRegion } from "features/regions/selectors";
import { getIsInParentSignUpPage } from "features/sign-up/links";

export default function useShowMarketingEmailsCheckboxByVariant() {
  const { pathname } = useLocation();
  const appVariant = useAppVariant();
  const region = useSelector(getRegion);
  const isGB = region === regionCodes.GB;
  const isInParentSignUp = getIsInParentSignUpPage(pathname);

  const valuesByVariant = {
    seneca: isGB && isInParentSignUp,
    senecaPrimary: false,
    plurall: false,
    goStudentLearning: false
  };

  return valuesByVariant[appVariant];
}
